module.exports = __webpack_public_path__ + "static/media/produzioni2.c1ea0702.png";